import BannerC from '../components/BannerC';

import FAQSection from '../components/FAQSection';
import SectionCard1 from '../components/SectionCard1';
import SectionCard2 from '../components/SectionCard2';
import SectionCard3 from '../components/SectionCard3';
import SeeMuch from '../components/SeeMuch';
import MultiSource from '../components/MultiSource';
import EcosystemSection from '../components/EcosystemSection';
import SuperchargeSectionStatusC from '../components/SuperchargeSectionStatusC';
import TCSection from '../components/TCSection';
export default function StatusItem() {
    return (
        <>
            {/* <Tip /> */}
            <BannerC />
            {/* <ExclusiveSectionStatusC /> */}
            {/* <EarlyBird endTime={new Date('2025/12/31 23:59:59 GMT+8').getTime()} /> */}
            <SeeMuch />
            <SuperchargeSectionStatusC />
            {/* <ExperienceApp /> */}
            {/* <SuperchargeSolarStatusC /> */}
            <SectionCard1 />
            <SectionCard2 />
            <MultiSource />
            <EcosystemSection />
            {/* <SectionCard3 /> */}
            <FAQSection />
            <TCSection />
        </>
    );
}
